import _ from "lodash";
import { Types } from "./quickbooksActions";



const quickbooksReducers = (state, action) => {
    switch (action.type) {
        case Types.QUICKBOOKS_OPTIONS: {

            let newState = _.cloneDeep(state);

            newState.integration.accounting.quickbooks = {
                ...newState.integration.accounting.quickbooks,
                ...action.data
            }

            return newState;
        }
        case Types.QUICKBOOKS_SAVING: {

            let newState = _.cloneDeep(state);

            newState.integration.accounting.quickbooks.saving = action.status ? action.status : undefined

            return newState;
        }
        case Types.QUICKBOOKS_SETTINGS: {

            let newState = _.cloneDeep(state);

            newState.integration.accounting.quickbooks = {
                ...newState.integration.accounting.quickbooks,
                ...action.settings
            }
            return newState;
        }
        case Types.QUICKBOOKS_OPTIONS_LOADING: {

            let newState = _.cloneDeep(state);

            newState.integration.accounting.quickbooks = {
                ...newState.integration.accounting.quickbooks,
                loading: action.status ? action.status : undefined
            }
            return newState;
        }
        case Types.QUICKBOOKS_EMPLOYEE_LINKS: {

            let newState = _.cloneDeep(state);

            newState.integration.accounting.quickbooks.links = action.links ? action.links : undefined
            newState.integration.accounting.quickbooks.employees = action.employees ? action.employees : undefined

            return newState;
        }
        case Types.QUICKBOOKS_SEND_DATA: {

            let newState = _.cloneDeep(state);

            const sending = newState.integration?.accounting?.quickbooks?.sendingPayroll

            let sendingPayroll = [...(Array.isArray(sending) ? sending : [])]

            if (action.status) {
                sendingPayroll.push(action.periodId)
            } else {
                sendingPayroll = sendingPayroll?.filter(item => item != action.periodId)
            }

            newState.integration.accounting = {
                ...newState.integration?.accounting,
                quickbooks: {
                    ...newState.integration?.accounting?.quickbooks,
                    sendingPayroll
                }
            }

            return newState;
        }
        default:
            return state;
    }
};

export default quickbooksReducers;